import React, { Suspense, lazy } from "react"
import { Route } from "react-router-dom"
import { isEducationPersonaSwitcherEnabled } from "./personaStore"

export const EDUCATION_PERSONA_SWITCHER_PATH = "/education"

// Loaded on demand so persona data stays out of the main bundle.
const EducationPersonaSwitcher = lazy(
  () => import("./EducationPersonaSwitcher"),
)

const EducationPersonaSwitcherGate = props =>
  isEducationPersonaSwitcherEnabled() ? (
    <Route
      path={EDUCATION_PERSONA_SWITCHER_PATH}
      render={() => (
        <Suspense fallback={null}>
          <EducationPersonaSwitcher {...props} />
        </Suspense>
      )}
    />
  ) : null

export default EducationPersonaSwitcherGate
